import react from "react";
import images from "../../constant/images";
import { Nav } from "../../layouts/navbar/nav";
import "./apropos.css";
import { Mission } from "./components/mission";
import { Temoignages } from "./components/temoignages";
import Partenairs from "./components/gallery";
// import Footer from "../../layouts/footer/footer";
import { useTranslation } from "react-i18next";
import Header from "../../layouts/header";

export const Apropos = () => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div className="flex flex-col mb-20">

      <Header image={images.about} title={t("aboutUs_content.about")}/>

      {/* Founder Section */}
      <div id="Fondateur" className="flex flex-col gap-5">
        <h1 className="text-center text-3xl md:text-4xl karla-font leading-relaxed tracking-wide">
          {t("aboutUs_content.founder")}
        </h1>
        <div className="flex flex-col md:flex-row w-full md:w-[80%] justify-center gap-8 mx-auto px-4 md:px-0">
          <div className="w-full md:w-auto">
            <img
              src={images.ceo}
              alt="CEO"
              className="w-full h-auto max-w-[325px] mx-auto"
            />
          </div>
          <div className="w-full md:w-[50%] flex flex-col gap-4">
            <p className="karla-font leading-relaxed tracking-wide">
              {t("aboutUs_content.founder_content.p1")}
            </p>
            <ul className="list-disc ml-[25px]">
              <li className="karla-font leading-relaxed tracking-wide">
                {t("aboutUs_content.founder_content.p2")}
              </li>
              <li className="karla-font leading-relaxed tracking-wide">
                {t("aboutUs_content.founder_content.p3")}
              </li>
              <li className="karla-font leading-relaxed tracking-wide">
                {t("aboutUs_content.founder_content.p4")}
              </li>
            </ul>
            <p className="karla-font leading-relaxed tracking-wide">
              {t("aboutUs_content.founder_content.p5")}
            </p>
          </div>
        </div>
      </div>

      {/* Mission Section */}
      <div id="Mission">
        <Mission />
      </div>

      {/* Testimonials Section */}
      <div>
        <Temoignages />
      </div>

      {/* Partners Section */}
      {/* <div>
        <Partenairs />
      </div> */}
    </div>
  );
};
